import { useSelector } from 'react-redux';
//
import MAvatar, { MAvatarProps } from './@material-extend/MAvatar';
import createAvatar from '../utils/createAvatar';
import { AppState } from '../Common/Reducer/rootReducerTypes';
import { useDisplayName } from '../hooks/useDisplayName';
// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: MAvatarProps) {
  const user = useSelector((state: AppState) => state.user);
  const userInfoState = useSelector((state: AppState) => state.userInfo);

  let displayName = "";
  let pictureUrl;

  if (user && user.profile) {
    displayName = useDisplayName();

    if (user.profile.picture) {
      pictureUrl = `${user.profile.picture}`;
    }
  }

  return (
    <MAvatar
      src={pictureUrl}
      alt={displayName}
      color={pictureUrl ? 'default' : createAvatar(displayName).color}
      {...other}
    >
      {createAvatar(displayName).name}
    </MAvatar>
  );
}
